export const AUTOMATION_AUTHORING_MODE = {
  LEGACY: 'legacy',
  JOURNEYS: 'journeys',
};

export function getAutomationAuthoringMode(hasJourneys) {
  return hasJourneys === true
    ? AUTOMATION_AUTHORING_MODE.JOURNEYS
    : AUTOMATION_AUTHORING_MODE.LEGACY;
}
